import {Controller} from "@hotwired/stimulus";

// Handles order form submission with discount metadata
export default class extends Controller {
  static targets = ['hiddenFields']

  connect() {
    this.isProcessing = false;
  }

  handleSubmit(event) {
    this.hiddenFieldsTarget.innerHTML = ''
    // If already processed, let it submit normally
    if (this.isProcessing) return;

    // Get the order summary controller
    const orderSummaryController = this.orderSummaryController;

    if (!orderSummaryController) {
      console.error('Order summary controller not found');
      return;
    }

    // Get formatted tickets with discount metadata
    const formattedTickets = orderSummaryController.getTicketsForSubmission();

    // Check if there are any tickets
    if (Object.keys(formattedTickets).length === 0) {
      console.warn('No tickets selected');
      return;
    }

    // Add new ticket fields with discount metadata
    Object.keys(formattedTickets).forEach(ticketId => {
      const ticketData = formattedTickets[ticketId];
      // Create hidden fields for quantity, discount_type, and discount_id
      this.addHiddenField(`tickets[${ticketId}][discount_type]`, ticketData.discount_type);

      if (ticketData.discount_id) {
        this.addHiddenField(`tickets[${ticketId}][discount_id]`, ticketData.discount_id);
      }
    });
  }

  addHiddenField(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    this.hiddenFieldsTarget.appendChild(input);
  }

  get orderSummaryController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "order-summary";
    });
  }

  disconnect() {
    // Clean up event listener using the stored bound reference
    if (this.boundHandleSubmit) {
      this.element.removeEventListener('submit', this.boundHandleSubmit);
    }
  }
}